<template>
  <div class="content">
    <card>
      <h3 slot="header" class="card-title ml-2">Financeiro</h3>
      <button
        v-if="mostrarImprimir"
        class="btn btn-success btn-fill"
        @click="imprimir"
      >
        Imprimir
      </button>
      <h4 class="ml-2">Data de emissão: {{ this.formatarData() }}</h4>
      <h4 v-if="avalChefeDepartamento" class="ml-2">
        Aval chefe de departamento: {{ avalChefeDepartamento }}
      </h4>
      <div class="text-center" v-if="codigoCliente && nomeCliente">
        <div class="mb-1">
          <label>Código:</label>
          <span>
            <strong>{{ codigoCliente }}</strong>
          </span>
        </div>
        <div class="mb-3">
          <label>Nome:</label>
          <span>
            <strong>{{ nomeCliente }}</strong>
          </span>
        </div>
      </div>
      <h4 class="card-title ml-2">Saídas</h4>
      <div class="overflow-auto">
        <l-table
          class="table-hover table-striped"
          :columns="dataTableSaidas.columns"
          :data="dataTableSaidas.data"
        >
          <template slot-scope="{ row, rowIndex }">
            <td>
              <b>{{ row.descricao }}</b>
            </td>
            <td>
              <b>{{ row.valor }}</b>
            </td>
          </template>
        </l-table>
        <h4 class="ml-2">Total: {{ somaSaidas }}</h4>
      </div>
      <h4 class="card-title ml-2">Entradas</h4>
      <div class="overflow-auto">
        <l-table
          class="table-hover table-striped"
          :columns="dataTableEntradas.columns"
          :data="dataTableEntradas.data"
        >
          <template slot-scope="{ row, rowIndex }">
            <td>
              <b>{{ row.descricao }}</b>
            </td>
            <td>
              <b>{{ row.valor }}</b>
            </td>
          </template>
        </l-table>
        <h4 class="ml-2">Total: {{ somaEntradas }}</h4>

        <h4 class="ml-2">Receita: {{ receita }}</h4>
      </div>
      <p class="mt-3 text-center">Balanço</p>
      <bar-chart
        :options="opcoesGraficoMensal"
        v-show="graficos"
        :chart-data="graficos.mensal"
        :style="graficosStyles"
      ></bar-chart>
      <p class="mt-3 text-center" v-if="!codigoCliente">Análise Anual</p>
      <line-chart
        v-if="!codigoCliente"
        :options="opcoesGraficoMensal"
        v-show="graficos"
        :chart-data="graficos.anual"
        :style="graficosStyles"
      ></line-chart>
    </card>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue';
import LTable from 'src/components/Table';
import BarChart from 'src/components/BarChart';
import LineChart from 'src/components/LineChart';
import format from 'date-fns/format';
const colunas = ['Descrição', 'Valor'];
export default {
  components: {
    Card,
    LTable,
    BarChart,
    LineChart
  },
  data() {
    return {
      dataTableSaidas: {
        columns: [],
        data: []
      },
      dataTableEntradas: {
        columns: [],
        data: []
      },
      nomeCliente: '',
      codigoCliente: '',
      graficos: {},
      opcoesGraficoMensal: {},
      graficosStyles: {
        height: '300px',
        width: '100%',
        position: 'relative'
      },
      somaSaidas: '',
      somaEntradas: '',
      receita: 0,
      avalChefeDepartamento: '',
      mostrarImprimir: true
    };
  },
  mounted() {
    this.dataTableSaidas.columns = colunas;
    this.dataTableEntradas.columns = colunas;
    this.$router.history.current.params;
    this.codigoCliente = this.$router.history.current.params.codigoCliente;
    this.nomeCliente = this.$router.history.current.params.nomeCliente;
    this.graficos = this.$router.history.current.params.graficos;
    this.avalChefeDepartamento = this.$router.history.current.params.avalChefeDepartamento;
    this.opcoesGraficoMensal = this.$router.history.current.params.opcoesGraficoMensal;
    this.preencherTabela(this.$router.history.current.params);
  },
  methods: {
    formatarData() {
      return format(new Date(), 'dd/MM/yyyy');
    },
    imprimir() {
      this.mostrarImprimir = false;

      setTimeout(function() {
        window.print();
      }, 500);
    },
    calculaSaidasEntradasGerais(
      somaSaidaGeral,
      somaEntradaGeral,
      saidasClientes = 0,
      entradasClientes = 0
    ) {
      let somaClientesSaidas = 0;
      let somaClientesEntradas = 0;
      saidasClientes.forEach(saida => {
        somaClientesSaidas =
          parseFloat(somaClientesSaidas) + parseFloat(saida.valor);
      });
      entradasClientes.forEach(entrada => {
        somaClientesEntradas =
          parseFloat(somaClientesEntradas) + parseFloat(entrada.valor);
      });
      this.somaEntradas = parseFloat(somaEntradaGeral) + somaClientesEntradas;
      this.somaSaidas = parseFloat(somaSaidaGeral) + somaClientesSaidas;
      this.receita = this.somaEntradas - this.somaSaidas;
      this.receita = this.receita.toFixed(2);
      this.somaEntradas = this.somaEntradas.toFixed(2);
      this.somaSaidas = this.somaSaidas.toFixed(2);
    },
    preencherTabela(params) {
      if (!params.saidasClientes) {
        params.saidasClientes = [];
      } else {
        params.saidasClientes.forEach((saida, index) => {
          params.saidasClientes[index].valor = saida.valor.$numberDecimal;
        });
      }
      this.dataTableSaidas.data = [...params.saidas, ...params.saidasClientes];

      if (!params.entradasClientes) {
        params.entradasClientes = [];
      } else {
        params.entradasClientes.forEach((saida, index) => {
          params.entradasClientes[index].valor = saida.valor.$numberDecimal;
        });
      }
      this.dataTableEntradas.data = [
        ...params.entradas,
        ...params.entradasClientes
      ];
      this.calculaSaidasEntradasGerais(
        params.somaSaidas.$numberDecimal,
        params.somaEntradas.$numberDecimal,
        params.saidasClientes,
        params.entradasClientes
      );
    }
  }
};
</script>
<style>
.border-bottom-1 {
  border-bottom: 1px !important;
  border-bottom-width: 1px !important;
}
a {
  color: black;
}
.file {
  margin-bottom: 2%;
}
.item-file {
  display: grid;
  text-align: center;
  justify-items: center;
}
.p-h-1 {
  padding-right: 1em;
  padding-left: 1em;
}
</style>
